/**
 * Function for lazy loading (code split) the map, and instantiating
 * via callback once loaded
 */
const lazyLoadedMap = cb => {
    import(/* webpackChunkName: "ddl-lazy-map" */ "./map").then(
        ({default: initMap}) => cb(initMap)
    );
}

export default (selector, options = {}) => {
    const elements = document.querySelectorAll(selector);
    if (elements.length) {
        lazyLoadedMap((initMap) => {
            elements.forEach(mapRoot => initMap(mapRoot, options));
        });
    }
};
